// eslint-disable-next-line no-unused-vars
import {
  Card,
  CardContent,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  Typography,
} from '@growdash/design-system/atoms';
// @ts-ignore
import GrowintelImage from '@components/atoms/growintel-image';
import { UniqueMenuItem } from '../../generated';
import useCurrency from '../../hooks/useCurrency';

const HoverCard = (item: UniqueMenuItem) => {
  const {
    item_name,
    item_image,
    avg_price,
    min_price,
    max_price,
    item_description,
  } = item;

  const currency = useCurrency();
  const priceValue = avg_price ?? max_price ?? min_price ?? null;

  return (
    // Used temporarily since tooltip content is outside of dom tree so that .growintel scope is not visible to it

    <div className="animate-fade-in px-2 py-3 bg-background border shadow-lg border-secondary rounded-lg">
      <div className="flex items-start gap-4">
        <div className="relative h-12 w-12 sm:h-24 sm:w-24 flex-shrink-0 rounded-md overflow-hidden bg-muted">
          <GrowintelImage src={item_image ?? ''} className="" />
        </div>

        <div className="flex-1 items-start min-w-0">
          <Typography className="text-[0.8125rem] font-medium max-w-64">
            {item_name}
          </Typography>
          <Typography className="font-bold mt-2 text-xs">
            {priceValue && priceValue > 0
              ? `
                ${priceValue.toFixed(1)} ${currency}`
              : '--'}
          </Typography>
        </div>
      </div>

      <Typography className="text-[0.8125rem] font-medium mt-2 max-w-96">
        {item_description ?? ''}
      </Typography>
    </div>
  );
};

export default function MenuItemCard(item: UniqueMenuItem) {
  const { item_name, item_image, avg_price, item_description } = item;
  const currency = useCurrency();
  return (
    <TooltipProvider>
      <Tooltip delayDuration={200}>
        <TooltipTrigger asChild>
          <Card className="border-tertiary w-full animate-fade-in rounded-lg max-h-max">
            <CardContent className=" p-2 cursor-pointer">
              <div className="flex items-start gap-2">
                <div className="relative w-12 h-12 xl:h-20 xl:w-20 flex-shrink-0 rounded-md overflow-hidden bg-secondary">
                  <GrowintelImage className='w-full h-full' src={item_image ?? ''} />
                </div>

                <div className="flex-1 min-w-0">
                  <Typography className="text-xs font-medium text-secondary truncate">
                    {item_name}
                  </Typography>
                  {!!item_description?.length && (
                    <Typography className="my-1 text-quarternary text-xs line-clamp-2">
                      {item_description}
                    </Typography>
                  )}
                  <Typography className="mt-1 font-bold text-xs">
                    {avg_price && avg_price > 0 ? (
                      `${avg_price.toFixed(1)} ${currency}`
                    ) : (
                      <span className="text-tertiary">--</span>
                    )}
                  </Typography>
                </div>
              </div>
            </CardContent>
          </Card>
        </TooltipTrigger>
        <TooltipContent asChild>{<HoverCard {...item} />}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
